module.exports = __webpack_public_path__ + "img/search-solid.8297cd8d.svg";